import createIcon from '../../createIcon';

/**
 * @component @name BorderColor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMjMuMDAxNUgyVjE5LjAwMTVIMjJWMjMuMDAxNVpNMTMuMDYgNC4xOTE1MkwxNi44MSA3Ljk0MTUyTDcuNzUgMTcuMDAxNUg0VjEzLjI1MTVMMTMuMDYgNC4xOTE1MlpNMTcuODggNi44NzE1MkwxNC4xMyAzLjEyMTUyTDE1Ljk2IDEuMjkxNTJDMTYuMzUgMC45MDE1MjMgMTYuOTggMC45MDE1MjMgMTcuMzcgMS4yOTE1MkwxOS43MSAzLjYzMTUyQzIwLjEgNC4wMjE1MiAyMC4xIDQuNjUxNTIgMTkuNzEgNS4wNDE1MkwxNy44OCA2Ljg3MTUyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderColor = createIcon('BorderColor', [
  [
    'path',
    {
      d: 'M22 23.0015H2V19.0015H22V23.0015ZM13.06 4.19152L16.81 7.94152L7.75 17.0015H4V13.2515L13.06 4.19152ZM17.88 6.87152L14.13 3.12152L15.96 1.29152C16.35 0.901523 16.98 0.901523 17.37 1.29152L19.71 3.63152C20.1 4.02152 20.1 4.65152 19.71 5.04152L17.88 6.87152Z',
      key: '1i88p2',
    },
  ],
]);

export default BorderColor;
